import React from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import InventoriesByStatusByComponent from "../../../components/inventory/ByStatus/byComponent";
import capitalizeText from "../../../utils/capitalizeText";
import { Breadcrumb } from "../../../components/Breadcrumb";

class InventoriesByStatusByComponentScreen extends React.Component {
  render() {
    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <Breadcrumb
              homeUrl="/dashboard/component%20production"
              data={[
                {
                  name: capitalizeText(this.props?.routeParams?.status),
                  url: "/dashboard/production/inventory/byStatus/pending",
                },
                {
                  name: this.props?.routeParams?.componentName,
                  active: true,
                },
              ]}
            />
            <InventoriesByStatusByComponent {...this.props?.routeParams} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(
  withRouter(InventoriesByStatusByComponentScreen)
);
